import '@/assets/main.css';
import '@globalhive/vuejs-tour/dist/style.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';

import App from '@/App.vue';
import axios from '@/plugins/axios';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import ZxcvbnPlugin from '@/plugins/zxcvbn';
import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import { useNotificationStore } from '@/stores/notification';
import { processErrorWithFeedback } from '@/utils/error';
import { Chart, registerables } from 'chart.js';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import ToastPlugin from 'vue-toast-notification';

const requiredEnvVars = ['VITE_ENVIRONMENT', 'VITE_API_URL'];

requiredEnvVars.forEach((key) => {
    if (!import.meta.env[key]) {
        const errorMsg = `Missing required environment variable: ${key}`;
        processErrorWithFeedback(`Bepaalde configuraties zijn niet goed ingesteld, neem contact op met een beheerder van 't Web.`, errorMsg);
    }
});

const app = createApp(App);

app.use(vuetify);
app.use(createPinia());
app.use(axios);
app.use(ToastPlugin);
app.use(ZxcvbnPlugin);
app.use(i18n);

const authStore = useAuthStore();
const notificationStore = useNotificationStore();

await authStore.refreshLoginState();

if (authStore.isAuthenticated) {
    await authStore.updateEmployeeOrganizations();
    await notificationStore.getForLoggedInEmployee();
}

app.use(router);

app.mount('#app');

Chart.register(...registerables);
